import { gql } from '@apollo/client'

const BASE_TEAM_MEMBER_FIELDS = gql`
  fragment BaseTeamMemberFields on TeamMemberType {
    id
    fullName
    slug
    degree
    position
    university
    authorPageDescription
    authorPageHighlights
    authorPageCredentials
    aboutAuthorDescription
    videoInstructorDescription
  }
`

export const GET_LIST_TEAM_MEMBER = gql`
  ${BASE_TEAM_MEMBER_FIELDS}
  query findAllTeamMember($params: TeamMemberQueryInput = {}) {
    findAllTeamMember(query: $params) {
      count
      items {
        ...BaseTeamMemberFields
        getAvatar {
          photo
        }
        link {
          id
          order
          platform {
            id
          }
        }
      }
    }
  }
`

export const GET_LIST_TEAM_MEMBER_BY_PLATFORM = gql`
  ${BASE_TEAM_MEMBER_FIELDS}
  query findAllTmLink($query: TmLinkQueryInput = {}) {
    findAllTmLink(query: $query) {
      count
      items {
        teamMember {
          ...BaseTeamMemberFields
          getAvatar {
            photo
          }
        }
      }
    }
  }
`

export const GET_ONE_TEAM_MEMBER = gql`
  ${BASE_TEAM_MEMBER_FIELDS}
  query findOneTeamMember($params: String!) {
    findOneTeamMember(id: $params) {
      ...BaseTeamMemberFields
      getAvatar {
        photo
      }
    }
  }
`

export const CREATE_TEAM_MEMBER = gql`
  ${BASE_TEAM_MEMBER_FIELDS}
  mutation createTeamMember($params: CreateTeamMemberInput!) {
    createTeamMember(createTeamMemberInput: $params) {
      ...BaseTeamMemberFields
      getAvatar {
        photo
      }
    }
  }
`

export const UPDATE_TEAM_MEMBER = gql`
  ${BASE_TEAM_MEMBER_FIELDS}
  mutation updateTeamMember($params: UpdateTeamMemberInput!) {
    updateTeamMember(updateTeamMemberInputFieldName: $params) {
      ...BaseTeamMemberFields
      getAvatar {
        photo
      }
    }
  }
`

export const DELETE_TEAM_MEMBER = gql`
  mutation removeTeamMember($params: String!) {
    removeTeamMember(id: $params) {
      affected
    }
  }
`

export const SEARCH_TEAM_MEMBER = gql`
  ${BASE_TEAM_MEMBER_FIELDS}

  query searchTeamMember($searchString: String, $isPresentPlatformSlug: String, $excludeIds: [String!]) {
    searchTeamMember(
      searchString: $searchString
      isPresentPlatformSlug: $isPresentPlatformSlug
      excludeIds: $excludeIds
    ) {
      count
      items {
        ...BaseTeamMemberFields
        getAvatar {
          photo
        }
        link {
          id
          order
          platform {
            id
          }
        }
      }
    }
  }
`

export const CREATE_TEAM_MEMBERS_LINK = gql`
  mutation createTmLink($createTmLinkInput: CreateTmLinkInput!) {
    createTmLink(createTmLinkInput: $createTmLinkInput) {
      id
      order
      platform {
        id
      }
    }
  }
`

export const UPDATE_TEAM_MEMBERS_LINK = gql`
  mutation updateTmLink($updateTmLinkInputFieldName: UpdateTmLinkInput!) {
    updateTmLink(updateTmLinkInputFieldName: $updateTmLinkInputFieldName) {
      id
      order
      platform {
        id
      }
    }
  }
`

export const REMOVE_TEAM_MEMBERS_LINK = gql`
  mutation removeTmLink($removeTmLinkId: String!) {
    removeTmLink(id: $removeTmLinkId) {
      affected
    }
  }
`

export const BULK_UPDATE_TEAM_MEMBERS_LINK = gql`
  mutation bulkUpdateTmLink($bulkUpdateTmLinkInput: [BulkUpdateTmLinkInput!]!) {
    bulkUpdateTmLink(bulkUpdatePtLinkInput: $bulkUpdateTmLinkInput) {
      id
    }
  }
`
